var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoc24Docx = function SvgDoc24Docx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5V8.922a5 5 0 0 0-1.877-3.904L15.72 3.096A5 5 0 0 0 12.597 2H9ZM6 7a3 3 0 0 1 3-3h3.597c.135 0 .27.01.403.027V6a2 2 0 0 0 2 2h2.855a3 3 0 0 1 .145.922V17a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V7Z",
    fill: "#4691DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.721 16.247a.975.975 0 0 0 1.895.013l1.227-4.865c.028-.127.052-.244.07-.35.02-.102.04-.21.056-.326a.028.028 0 0 1 .028-.024c.014 0 .026.01.028.024.017.115.034.224.051.326.022.11.049.226.081.35l1.214 4.857a.988.988 0 0 0 1.92-.013l1.529-6.475a.62.62 0 1 0-1.212-.273l-1.094 5.114a5.06 5.06 0 0 0-.066.317l-.034.285a.03.03 0 0 1-.06 0 6.985 6.985 0 0 0-.101-.602L13.056 9.76a1.008 1.008 0 0 0-1.957.007L9.937 14.61c-.029.124-.05.23-.065.318l-.035.284a.03.03 0 0 1-.06 0 5.076 5.076 0 0 0-.105-.602L8.552 9.544a.693.693 0 1 0-1.35.309l1.518 6.394Z",
    fill: "#4691DD"
  })));
};
export default SvgDoc24Docx;